import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import { IPageHeaderEntity } from '@web-nx-ng-tsc/web-shared-data-access';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';

@Component({
  selector: 'lib-web-shared-ui-page-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './lib-page-header.component.html',
  styleUrl: './lib-page-header.component.scss',
})
export class LibPageHeaderComponent {
  @Input() set data(value: IPageHeaderEntity) {
    this.loggingService.warn('###INPUT | data :', value);
    this.dataSignal.set(value);
  }

  @Output() emitPathUrl = new EventEmitter();

  private readonly loggingService = inject(LoggingService);

  dataSignal = signal<IPageHeaderEntity>({
    pageTitle: '',
    pageSubTitle: '',
    subTitles: [],
  });

  onClickPathUrl(url: string, currentUrl: boolean) {
    if (!currentUrl && url) {
      this.emitPathUrl.emit(url);
    }
  }
}
